import Vue from 'vue';
import Router from 'vue-router';
import store from '../store/index';
import * as types from '../store/mutation-types';

Vue.use(Router);

function loadView(view) {
    return () => import(`@/views/${view}.vue`);
}

const router = new Router({
    mode: 'history',
    routes: [
        {
            path: '/',
            name: 'index',
            component: loadView("Index"),
            meta: {requireAuth: true},
            children: [
                {
                    path: 'customers_list',
                    name: 'customers_list',
                    component: loadView('franchisee/CustomersList'),
                    meta: {requireAuth: true}
                },
                {
                    path: 'customers_list_details',
                    name: 'customers_list_details',
                    component: loadView('franchisee/children/CustomersListDetails'),
                    meta: {requireAuth: true, keepPar: true}
                },
                {
                    path: 'pools_list',
                    name: 'pools_list',
                    component: loadView('franchisee/PoolsList'),
                    meta: {requireAuth: true}
                },
                {
                    path: 'address',
                    name: 'address',
                    component: loadView('franchisee/Address'),
                    meta: {requireAuth: true}
                },
                {
                    path: 'source_clues',
                    name: 'source_clues',
                    component: loadView('franchisee/SourceClues'),
                    meta: {requireAuth: true}
                },
                {
                    path: 'student_side',
                    name: 'student_side',
                    component: loadView('franchisee/StudentSide'),
                    meta: {requireAuth: true}
                },
                {
                    path: 'order_list',
                    name: 'order_list',
                    component: loadView('order/OrderList'),
                    meta: {requireAuth: true}
                },
                {
                    path: 'add_order',
                    name: 'add_order',
                    component: loadView('order/children/AddOrder'),
                    meta: {requireAuth: true}
                },
                {
                    path: 'source_list',
                    name: 'source_list',
                    component: loadView('source/SourceList'),
                    meta: {requireAuth: true}
                },
                {
                    path: 'promotion',
                    name: 'promotion',
                    component: loadView('marketing/Promotion'),
                    meta: {requireAuth: true}
                },
                {
                    path: 'promotion_details',
                    name: 'promotion_details',
                    component: loadView('marketing/children/PromotionDetails'),
                    meta: {requireAuth: true}
                },
                {
                    path: 'privilege',
                    name: 'privilege',
                    component: loadView('privilege/Privilege'),
                    meta: {requireAuth: true}
                },
                {
                    path: 'jurisdiction',
                    name: 'jurisdiction',
                    component: loadView('privilege/children/jurisdiction'),
                    meta: {requireAuth: true}
                },
                {
                    path: 'staff_list',
                    name: 'staff_list',
                    component: loadView('staff/StaffList'),
                    meta: {requireAuth: true}
                },
                {
                    path: 'login_info',
                    name: 'login_info',
                    component: loadView('staff/LoginInfo'),
                    meta: {requireAuth: true}
                },
                {
                    path: 'password',
                    name: 'password',
                    component: loadView('password/Password'),
                    meta: {requireAuth: true}
                },
            ]
        },
        {
            path: '/login',
            name: 'login',
            component: loadView('Login')
        },
    ]
});

if (window.localStorage.getItem('jwt')) {
    store.commit(types.TOKEN, window.localStorage.getItem('jwt'));
}

if (window.localStorage.getItem('user_name')) {
    store.commit(types.USER_NAME, window.localStorage.getItem('user_name'));
}

if (window.localStorage.getItem('permission')) {
    store.commit(types.PERMISSION, window.localStorage.getItem('permission'));
}

router.beforeEach((to, from, next) => {
    if (to.matched.some(r => r.meta.requireAuth)) {
        if (store.state.token) {
            next();
        } else {
            next({
                path: '/login',
                query: {redirect: to.fullPath}
            });
        }
    } else {
        next();
    }
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js